<template>
  <v-app>
    <MainHeader />
    <v-main>
      <router-view v-if="isLoaded" />
    </v-main>
  </v-app>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import MainHeader from '@/components/main-header/MainHeader.vue'
import { REQUEST_OFFER_DATA } from '@/store/modules/offer/actions'

export default {
  name: 'App',

  components: {
    MainHeader,
  },

  data() {
    return {
      loaded: false,
    }
  },
  computed: {
    ...mapGetters('roles', ['getRole']),
    ...mapState('process', ['isProcessStarted']),
    isLoaded() {
      return (
        this.isProcessStarted ||
        this.$route.path === '/admin' ||
        this.$route.path === '/401' ||
        this.$route.path === '/404'
      )
    },
  },
  methods: {
    ...mapActions('offer', [REQUEST_OFFER_DATA]),
    ...mapActions('roles', ['setRole', 'setValid']),
    ...mapMutations('process', ['setIsProcessStarted']),
    async setOffer() {
      const offer = await this[REQUEST_OFFER_DATA]({
        offerId: this.$route.params.offerId,
      })
      this.startOffer(offer)
    },
    startOffer(offer) {
      if ('error' in offer) {
        this.$router.push('/404')
      } else {
        this.setIsProcessStarted(true)
      }
    },
  },
  created() {
    this.setRole(this.$route.query.role)
    this.setValid(this.getRole)

    if (this.$route.path !== '/404' && this.$route.path !== '/401') {
      if (!this.getRole) {
        this.$router.push('/401')
      } else if (this.getRole !== 'admin' && this.$route.path === '/admin') {
        this.$router.push('/401')
      } else if (this.$route.path !== '/admin') {
        this.setOffer()
      }
    }
  },
}
</script>

<style>
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
